import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {getWidgetValues} from "sportinglife-react-common/widgets";

const PROPS_MAP = {
  class_name: "className",
  item_id:    "data-id",
  embed_by:   "data-embed-by",
  shares:     "data-shares",
  comments:   "data-comments",
  version:    "data-version",
  game_info:  "data-game-info",
  recommend:  "data-recommend"
};

const PROPS_LIST = Object.keys(PROPS_MAP);

export function playbuzzPropsFromWidget(widget) {
  return getWidgetValues(widget, PROPS_LIST);
}

export default class PlaybuzzEmbed extends Component {
  static propTypes = {
    data: PropTypes.object
  };

  componentDidMount() {
    // add the script on demand, but only once (Helmet repeats it)
    if (!window.PlayBuzz) {
      const script = document.createElement('script');
      script.src = '//cdn.playbuzz.com/widget/feed.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }

  render() {
    const divProps = PROPS_LIST.reduce((o, k) => {
      if (this.props.hasOwnProperty(k)) {
        return {
          ...o,
          [PROPS_MAP[k]]: this.props[k]
        };
      }
      else {
        return o;
      }
    }, {});

    return <div {...divProps}/>;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/PlaybuzzEmbed.js